import useCollectGraphicsFilterHook from "./use-collect-graphics-filter-hook";

const CollectGraphicsHooks = {
    useFilter: useCollectGraphicsFilterHook
};

export default CollectGraphicsHooks;
